import first from "lodash/first";

import { parseQueryString } from "scmp-app/lib/utils";

export const letters = [
  ...Array.from({ length: 26 }).map((_item, index) => String.fromCodePoint(index + 97)),
  "others",
];

export const isValidLetter = (letter: string): boolean => letters.includes(letter);

export const getLetterFromQueryString = (
  queryStringLetter: string | string[] | undefined,
): string => {
  const letter = parseQueryString(queryStringLetter);
  return letter && isValidLetter(letter) ? letter : (first(letters) as string);
};
